/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Current credits available for the customer
*/
export class GetCreditsResponse {
  /**
  * Total number of remaining credits available for the customer.
  */
  'totalRemainingCredits': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "totalRemainingCredits",
      "baseName": "totalRemainingCredits",
      "type": "number",
      "format": "int64"
    }  ];

  static getAttributeTypeMap() {
    return GetCreditsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

